import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { Navbar as NavbarBS, Nav } from "react-bootstrap";

import { cl } from "../../utilities/cl";

import User from "./User";
import ObjectsMenu from "../ObjectsMenu";
import NavbarCollapse from "../NavbarCollapse";

import iconLogo from "../../assets/icons/logo.png";
import SvgLogOut from "../SVG/LogOut";
import SvgServerSearch from "../SVG/ServerSearch";
import { useHistory } from "react-router-dom";
import AudioPlayerInline from "../AudioPlayerInline";
import { useDispatch, useSelector } from "react-redux";
import { resetPlace } from "../../store/Panel/actions";

const Navbar = ({ className = "", links }) => {
  const dispath = useDispatch();
  const onNavBarClicked = () => {
    dispath(resetPlace());
  };
  let path = window.location.href.split("/").pop();

  const isPlaying = useSelector((state) => state.audio.isPlaying);

  className = cl(className, "Navbar", "spp-container-p");
  let history = useHistory();
  const handleLogout = () => {
    localStorage.sessionToken = "";
    localStorage.removeItem("master");
    //localStorage.token = "";
    history.push("/login");
  };
  return (
    <NavbarBS className={className} bg="light" variant="light">
      {!isPlaying && (
        <NavbarBS.Brand href="/" onClick={onNavBarClicked}>
          <img
            className="spp-h-md"
            src={iconLogo}
            title="Сервис Поддержки Продвижения"
          />
        </NavbarBS.Brand>
      )}
      <AudioPlayerInline />
      <ObjectsMenu />

      <div className="d-flex justify-content-end w-100">
        {path !== "login" && (
          <div className="Navbar__Menu">
            {links.map((link) => (
              <NavLink
                to={link.href}
                className="nav-link only_trigger"
                key={link.id}
                onClick={onNavBarClicked}
              >
                {link.title}
              </NavLink>
            ))}
          </div>
        )}
        <User />
        <NavbarCollapse
          linksToTop={links}
          linksToBottom={[
            {
              id: 14,
              title: (
                <>
                  <SvgLogOut
                    className="Navbar__SvgLogOut"
                    size="sm"
                    onClick={() => handleLogout()}
                    variant="dark"
                    title="Выйти"
                  />
                  Выйти
                </>
              ),
              href: "#",
            },
          ]}
        />
      </div>
    </NavbarBS>
  );
};

Navbar.propTypes = {
  className: PropTypes.string,
  links: PropTypes.array,
};

export default Navbar;
